import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject, Subscription, takeUntil, debounceTime, distinctUntilChanged } from 'rxjs';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { UieventhubService } from '@src/app/helpers/uieventhub/uieventhub.service';
import { Project } from '@src/app/models/project';
import { Projectperson } from './model/projectperson';
import { DatastoreService } from '@src/app/helpers/datastore/datastore.service';
import { ImagestoreService } from '@src/app/helpers/imagestore.service';
import { ModalService } from '@src/app/helpers/modal.service';
import { untilDestroyed } from '@ngneat/until-destroy';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import {
  trigger,
  state,
  style,
  animate,
  transition,
} from "@angular/animations";
import { DailyEngagement, EngagementState } from '@src/app/components/pages/portal/engagement-gauge/models/engagement.model'
import { TimeregistrationService } from '@src/app/helpers/timeregistration/timeregistration.service';
import { ProjectTimeSummaryRow } from '@src/app/models/projecttimesummary';

@Component({
  selector: 'app-projectslist',
  templateUrl: './projectslist.component.html',
  styleUrls: ['./projectslist.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger("inbgOutAnimation", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("0.2s ease-out", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 1 }),
        animate("0.2s ease-in", style({ opacity: 0 })),
      ]),
    ]),
    trigger("taskdoneAnimation", []),
  ],
})
export class ProjectslistComponent implements OnInit, OnDestroy {
  @Output() projectList: Project[];
  allProjectsList: Project[] = [];
  filteredProjectList: Project[] = [];
  editProject: Project;
  automationProject: Project;
  projectToDelete: Project;
  personProject: Project;
  personprojList: Projectperson[];
  adminProjectList: Project[];
  customerProjectList: Project[];
  projectString: string;
  projectFilterType = '';
  projectFilterText: string;
  showNoProjectsMsg = false;
  showSpinner = true;
  showDisabled = false;
  filterTxt: string;
  filterTxtDebounced: string = '';
  showFilter: boolean;
  customerportal: boolean;
  orgedit: boolean;
  timeregEnabled: boolean = false;
  projectTimeSummaryMap = new Map<string, ProjectTimeSummaryRow>();
  winWidth: number;
  pnewidth: number;
  showalerttoggle: boolean;
  showerrortoggle: boolean;
  assignProject: Project;
  templateProject: Project;
  setActiveStateProject: Project;
  viewProjectList: Project[] = [];

  @ViewChild('personnameele') pne: ElementRef;
  @ViewChild('deleteProjectModal', { static: true }) deleteProjectModal: ElementRef;
  @ViewChild('orgProjectEditModal', { static: true }) orgProjectEditModal: ElementRef;

  collapsTimeout: any;
  disableTimeout: any;
  showDisabledTimeout: any;
  reset: boolean = false;
  private destroy$ = new Subject<void>();
  private filterInput$ = new Subject<string>();

  constructor(
    private router: Router,
    private uieventhub: UieventhubService,
    private datastore: DatastoreService,
    public cd: ChangeDetectorRef,
    private modalservice: ModalService,
    private authservice: AuthorizationService,
    private timeregSrv: TimeregistrationService,

  ) {
    this.winWidth = window.innerWidth;
  }

  currentYear = new Date().getFullYear();

  isOtherYear(date: any): boolean {
    return new Date(date).getFullYear() !== this.currentYear;
  }

  @HostListener('window:resize')
  onResize() {
    this.resized();
  }

  ngOnInit(): void {
    if (this.authservice.isAuthorized("orgedit",
      SessionHelper.getChoosenOrg())) {
      this.orgedit = true;
    } else {
      this.orgedit = false;
    }
    this.authservice.isAuthorized
    this.customerportal = !!SessionHelper.getCustomer();
    this.showDisabled = false;
    this.showSpinner = true;

    this.timeregEnabled = SessionHelper.hasModule('timereg') && !this.customerportal;
    if (this.timeregEnabled) {
      this.timeregSrv.getOrgTimeSummary()
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (rows) => {
            this.projectTimeSummaryMap = new Map(rows.map((row) => [row.projectId, row]));
            this.cd.markForCheck();
          },
          error: (err) => console.error('[Projectslist] Failed to load org time summary', err),
        });
    }

    this.uieventhub.projectsFilterType$
      .pipe(takeUntil(this.destroy$)).subscribe(type => {
        this.filterProjectsByType(type);
        this.cd.markForCheck();
      });

    this.uieventhub.showProjectListFilter$
      .pipe(takeUntil(this.destroy$)).subscribe(show => {
        this.showFilter = show;
        this.cd.markForCheck();
      });
    this.handleProjectData(this.datastore.projectList.getValue());
    this.datastore.projectList$
      .pipe(takeUntil(this.destroy$)).subscribe(data => {
        //console.log('Projects list:', data);
        this.handleProjectData(data);
      });

    this.uieventhub.showchatcollapse$
      .pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.collapsTimeout = setTimeout(() => {
          this.resized();
        }, 200);
      });

    this.uieventhub.removeLoader('portal');
    //this.uieventhub.removeLoader('projectportal');
    this.uieventhub.removeLoader('projectslist');
    this.uieventhub.removeLoader('projectlist');
    this.uieventhub.removeLoader('personname');
    this.uieventhub.removeLoader('projectportal_tasks');
    this.uieventhub.removeLoader('projectportal_stages');
    this.uieventhub.removeLoader('projectportal_comments');
    this.uieventhub.removeLoader('projprojectportal_customermembers');

    // Debounce filter input to reduce change detection churn
    this.filterInput$
      .pipe(debounceTime(150), distinctUntilChanged(), takeUntil(this.destroy$))
      .subscribe(val => {
        this.filterTxtDebounced = val || '';
        this.cd.markForCheck();
        this.applyFilters();
      });
  }

  ngAfterViewInit(): void {
    this.resized();
  }

  resized(): void {
    if (this.pne) {
      this.pnewidth = this.pne.nativeElement.clientWidth;
      this.cd.detectChanges();
    }
  }

  filterProjectsByType(type: string): void {
    if (!this.allProjectsList?.length) return;

    const isActive = !this.showDisabled;
    switch (type) {
      case '':
        this.projectList = this.allProjectsList.filter(p => p.isactive === isActive);
        break;
      case 'ontrack':
        this.projectList = this.allProjectsList.filter(p => p.overduedays == 0 && p.isactive === isActive);
        break;
      case 'almost':
        this.projectList = this.allProjectsList.filter(p => p.overduedays > 0 && p.overduedays < 3 && p.isactive === isActive);
        break;
      case 'notontrack':
        this.projectList = this.allProjectsList.filter(p => p.overduedays >= 3 && p.isactive === isActive);
        break;
    }

    this.sortProjects();
    this.filteredProjectList = [...this.projectList];
    this.applyFilters();
    this.cd.markForCheck();
  }

  handleProjectData(data: Project[]): void {
    this.allProjectsList = data;

    if (!data?.length) {
      this.showNoProjectsMsg = true;
      this.viewProjectList = [];
      return;
    }

    this.showNoProjectsMsg = false;

    if (this.customerportal && SessionHelper.getViewAsCustomer()) {
      const custId = JSON.parse(SessionHelper.getCustomer()).customerId.split('_')[0];
      this.allProjectsList = this.allProjectsList.filter(p => p.customer.split('_')[0] === custId);
    }

    this.projectList = this.allProjectsList.filter(p => p.isactive === !this.showDisabled);
    //this.generateMockEngagementIfMissing();
    this.sortProjects();
    this.filteredProjectList = [...this.projectList];
    this.applyFilters();
  }

  sortProjects(): void {
    this.uieventhub.addLoader('sortprojectslist');
    this.projectList.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
    this.uieventhub.removeLoader('sortprojectslist');
    this.cd.markForCheck();
  }

  clickEdit(project: Project): void {
    this.editProject = project;

    // show edit project modal
    this.modalservice.open(this.orgProjectEditModal);
  }

  clickAutomation(project: Project): void {
    this.automationProject = project;
    this.modalservice.open('projectAutomationModal');
  }


  clickTemplate(project: any) {
    this.templateProject = project;

    this.modalservice.open('projectTemplateModal');
  }

  clickWork(project: Project): void {
    //console.log('project work', project);
    this.uieventhub.addLoader('project');
    this.datastore.loadProjectDependentData([project]);
    this.uieventhub.setProjectDataLoading(true);
    this.uieventhub.setCurrentProject(project.projectId);
    SessionHelper.setCurrentProject(project.projectId);
    SessionHelper.setCurrentProjectName(project.title);
    SessionHelper.setCurrentProjectFull(JSON.stringify(project));

    this.router.navigate(['portal/project/' + project.projectId]);
  }
  clikcDisable(project: Project): void {
    //show confirm disable modal
    this.setActiveStateProject = project;
    this.disableTimeout = setTimeout(() => {
      this.modalservice.open('disableProjectModal');
    }
      , 200);
  }

  disabledProject(project: Project): void {
    this.setActiveStateProject.isactive = false;

  }
  clickDelete(project: Project): void {
    this.projectToDelete = project;
    this.modalservice.open(this.deleteProjectModal);

  }

  clickAssign(project: Project): void {
    // this.uieventhub.addLoader('projectassign');
    this.showSpinner = true;
    this.uieventhub.setAssignProject(project.projectId);
    this.datastore.loadProjectDependentData([project]);

    this.assignProject = project;
    this.modalservice.open('assignProjectModal');
  }
  closeSpinner(): void {
    this.showSpinner = false;
  }

  toggleDisabled(): void {
    this.showSpinner = true;
    this.showDisabled = !this.showDisabled;
    this.projectList = this.allProjectsList.filter(p => p.isactive === !this.showDisabled);
    this.filteredProjectList = [...this.projectList];
    this.sortProjects();
    this.applyFilters();

    this.showDisabledTimeout = setTimeout(() => {
      this.showSpinner = false;
    }, 200);
  }

  deletedProject(p: Project): void {
    this.allProjectsList = this.allProjectsList.filter(proj => proj !== p);
    this.filteredProjectList = this.filteredProjectList.filter(proj => proj !== p);
    this.projectList = this.projectList.filter(proj => proj !== p);
    this.showAlert(true);
    this.applyFilters();
  }

  showAlert(boolean) {
    this.showalerttoggle = boolean;
    if (this.showalerttoggle == true) {
      setTimeout(() => {
        this.showalerttoggle = false
      }, 1500);
    }
    if (this.showerrortoggle == true) {
      setTimeout(() => {
        this.showerrortoggle = false
      }, 1500);
    }
  }

  setFilteredList(list: Project[]): void {
    //console.log('set filtered list', list);
    this.filteredProjectList = list || [];
    this.applyFilters();
  }

  onFilterInput(value: string): void {
    this.filterTxt = value;
    this.filterInput$.next(value);
  }

  // TrackBy to avoid recreating DOM nodes for stable items
  trackByProjectId(index: number, project: Project): string | number {
    return project?.projectId ?? index;
  }

  projectTimeSummary(projectId: string): ProjectTimeSummaryRow | undefined {
    return this.projectTimeSummaryMap.get(projectId);
  }

  ngOnDestroy(): void {
    if (this.collapsTimeout) {
      clearTimeout(this.collapsTimeout);
    }
    if (this.disableTimeout) {
      clearTimeout(this.disableTimeout);
    }
    if (this.showDisabledTimeout) {
      clearTimeout(this.showDisabledTimeout);
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

  closemodal(boolean) {

    if (boolean == true) {
      //this.uieventhub.addLoader('projectassign');
      this.modalservice.close('assignProjectModal');
      this.reset = false;
    } else {
      this.reset = true;
      //this.uieventhub.removeLoader('projectassign');
    }
  }

  private applyFilters(): void {
    this.viewProjectList = this.filterByText(this.filteredProjectList, this.filterTxtDebounced);
    this.cd.markForCheck();
  }

  private filterByText(list: Project[], searchText: string): Project[] {
    if (!list) return [];
    if (!searchText) return [...list];
    const lower = searchText.toLocaleLowerCase();
    return list.filter(it => it.title?.toLocaleLowerCase().includes(lower));
  }

  private generateMockEngagementIfMissing(): void {
    // Generate mock engagement data only if missing to avoid expensive recomputation on every update
    for (let p of this.projectList) {
      if (!p.engagement || p.engagement.length === 0) {
        p.engagement = [];

        for (let i = 6; i >= 0; i--) {
          const date = new Date();
          date.setDate(date.getDate() - i);
          const dateString = date.toISOString().split('T')[0];

          const hasLogin = Math.random() > 0.3;
          const hasTaskActivity = Math.random() > 0.5;
          const hasCommentActivity = Math.random() > 0.7;

          let state: EngagementState;
          if (hasTaskActivity && hasCommentActivity) {
            state = EngagementState.ENGAGED;
          } else if (hasTaskActivity) {
            state = EngagementState.ACTIVITY;
          } else if (hasLogin) {
            state = EngagementState.LOGIN;
          } else {
            state = EngagementState.NONE;
          }

          p.engagement.push({
            date: dateString,
            state: state,
            hasLogin: hasLogin,
            hasTaskActivity: hasTaskActivity,
            hasCommentActivity: hasCommentActivity
          });
        }
      }
    }
  }
}
